import { useEffect } from 'react';

import { connectScrollTo } from 'react-instantsearch-dom';

const ScrollTo = ({ children, hasNotChanged }) => {

    useEffect(() => {
        if (!hasNotChanged) {
            window.scrollTo({
                top: 0,
                behavior: "auto"
            });
        }
    }, [hasNotChanged])

    return children;
}

export default connectScrollTo(ScrollTo);